import { useEffect, useRef, type RefObject } from "react"
import { Formik, getIn } from "formik"
import { CharField, SingleSelectField } from "@inmagik/magik-ui"
import * as yup from "yup"
import type { BlockBase, TextBlock } from "../../../../types"
import { WysiwygField } from "../../../../components/WysiwygField"
import { AutoValidate } from "./Autovalidate"
import { bgColorOptions } from "../../options"

export function TextBlockForm({
  block,
  saveBlock,
  setBlockFormValid,
  submitRef,
}: {
  block: BlockBase
  saveBlock: (b: BlockBase) => void
  setBlockFormValid: (v: boolean) => void
  submitRef: RefObject<HTMLButtonElement | null>
}) {
  const schema = yup.object().shape({
    slideTitle: yup.string().required("Il titolo della slide è obbligatorio"),
    content: yup.string().required("Il testo è obbligatorio"),
    color: yup.string().nullable(),
  })

  const hiddenSubmitRef = useRef<HTMLButtonElement>(null)

  useEffect(() => {
    if (!submitRef?.current) return
    submitRef.current.onclick = () => hiddenSubmitRef.current?.click()
  }, [submitRef])

  const initialValues: TextBlock = {
    uuid: block.uuid,
    blockType: "Text",
    slideTitle: (block as TextBlock).slideTitle ?? "",
    title: (block as TextBlock).title ?? "",
    content: (block as TextBlock).content ?? "",
    color: (block as TextBlock).color ?? "",
  }

  return (
    <Formik
      enableReinitialize
      initialValues={initialValues}
      validateOnMount
      validationSchema={schema}
      onSubmit={(values) => saveBlock(values)}
    >
      {({ handleSubmit, values, errors, setFieldValue }) => (
        <form onSubmit={handleSubmit}>
          <CharField
            label="Titolo slide"
            layout="horizontal"
            value={values.slideTitle}
            onChange={(v) => setFieldValue("slideTitle", v)}
            required
            isValid={!getIn(errors, "slideTitle")}
            errorMessage={getIn(errors, "slideTitle")}
            className="mb-3"
          />

          <CharField
            label="Titolo"
            layout="horizontal"
            value={values.title}
            onChange={(v) => setFieldValue("title", v)}
            isValid={!getIn(errors, "title")}
            errorMessage={getIn(errors, "title")}
            className="mb-3"
          />

          <WysiwygField
            label="Testo"
            layout="horizontal"
            value={values.content}
            onChange={(v) => setFieldValue("content", v)}
            required
            isValid={!getIn(errors, "content")}
            errorMessage={getIn(errors, "content")}
            className="mb-3"
          />

          <SingleSelectField
            label="Colore sfondo"
            layout="horizontal"
            options={bgColorOptions}
            value={bgColorOptions.find((o) => o.value === values.color) ?? null}
            onChange={(v) => setFieldValue("color", v?.value ?? "")}
            isValid={!getIn(errors, "color")}
            errorMessage={getIn(errors, "color")}
            placeholder="Seleziona un colore di sfondo"
          />

          <button ref={hiddenSubmitRef} type="submit" style={{ display: "none" }} />
          <AutoValidate setBlockFormValid={setBlockFormValid} />
        </form>
      )}
    </Formik>
  )
}